<template>
<div>


<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
<h4 >CLASSIFICAZIONE - <strong style="color:red">ITALIST.COM</strong></h4>


<div>
    <div class="form-group">
    <label  for="categoria"><strong>Categoria</strong></label>
        <select  @change="setData()"  id="category" name="category" class="form-control" v-model="product.categoryId">
        <optgroup v-for="(group, name,index) in items" :key="index" :label="name">
         
        <option v-for="(option,index) in group" :key="index" :value="option.value">
            {{ option.text  }}
        </option>
        </optgroup>
        </select> 
    </div>
</div>


<div class="form-group">
      <label  class="" for="product_name"><strong>Product Name</strong></label>      
      <input  @change="setData()" type="text"   class="form-control " id="product_name" placeholder="" v-model="product.product_name">
      
</div>
<button  type="button" @click="UpdateItalistProduct()"  class="btn btn-primary  mt-2 mr-1">
       <i class="fas fa-save mr-2" aria-hidden="true"></i>
       SALVA
       <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button>  


<button  type="button" @click="$emit('close')"  class="btn btn-outline-secondary mt-2 ml-1">
       <i class="far fa-window-close mr-2" aria-hidden="true"></i>
       CHIUDI        
</button> 





</div>

</template>

<script>

import { mapGetters } from 'vuex';


import alertBox          from '@/components/common/AlertBox.vue'

import {setCategory,sortCat} from '@/functions'; 

import api            from '@/api'



  export default {
  props : ['productId'],

     components: {alertBox},
    data () {
      return {
        
      
          
        items        : [],
        product      : {},       
        
        msg             : {title : '',body:'',type :0},
        
        spinner      : false,
        bt_spinner   : false
       

      }
    },

    
  
    computed: {
     ...mapGetters(['company']),

     
      
      
    },
    created () 
      {

        this.product.categoryId = JSON.parse(localStorage.getItem("italist_categoryId"))
        this.product.product_name = JSON.parse(localStorage.getItem("italist_product_name"))
        this.getData()
        this.getItalistProduct()
        
      },
    methods: 
    {
    
    setData()
    {      
      localStorage.setItem('italist_product_name',JSON.stringify(this.product.product_name))
      localStorage.setItem('italist_categoryId',JSON.stringify(this.product.categoryId))
    },
    setCategoryId(Id)
    {
        this.product.categoryId = Id
    },        
    async getItalistProduct()
    {
    
    this.spinner  = true
        
    var data      = {'productId' : this.productId}
    var sp        = {'sp' : 'spItalistProduct'}
    var json      = Object.assign(data, sp);
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              if(res.data.recordsets[0].length > 0) 
              {
                this.product = res.data.recordsets[0][0]
              }  

             

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.spinner = false
        });
  
    
    },   

  
      async getData()
      { 

        
        var sp        = {'sp' : 'spItalist_category'}
        
        await api.post(sp).then(res => {
          
          if(res.status==200)
            {
              if(res.data.recordsets[0].length > 0) 
              {
                this.items = setCategory(res.data.recordsets[0])
              }  

             

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.spinner = false
        });
  
    

      },
      
    async UpdateItalistProduct()
    {
    
    
      
    this.msg.title = ''
    if(!this.product.product_name || !this.product.categoryId)  
    {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Classificazione non completa.'
        this.msg.type  = 1
        return
    }

    this.bt_spinner  = true
    
    var data      = {'productId' : this.productId,'product_name' : this.product.product_name, 'categoryId':this.product.categoryId}
    var sp        = {'sp' : 'spUpdateItalistProduct'}

    var json      = Object.assign(data, sp);
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              //this.$emit('close')
              this.msg.title = 'Classificazione ITALIST.'
              this.msg.body = 'Classificazione effettuata.'
              this.msg.type  = 0

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.bt_spinner = false
        });
  
    
    },   
    

      
      

    }
  }
</script>
<style scoped>

p {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}

.selected
{
  color        : red;  
  font-family  : 'Roboto Condensed';
  font-weight  : bold;
  
  
}

 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
